/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { EMPTY_LIST_RESULT_STATE, ListResultState } from 'app/shared/models/list-result-state.model';

// Intermediary service
// To all calling the applyFilter method in the filter component from a child component
@Injectable()
export class ListFilterIntermediaryService {
	private subject = new Subject<any>();
	private resultState = new BehaviorSubject<ListResultState>(EMPTY_LIST_RESULT_STATE);
	private resultStateSubscription?: Subscription;
	resultState$ = this.resultState.asObservable();

	callParentMethod(message: string) {
		this.subject.next({ text: message });
	}

	getParentMethod(): Observable<any> {
		return this.subject.asObservable();
	}

	/** One-way bridge from a list service to filter/results-summary presentation. */
	connectResultState<T>(source: Observable<ListResultState<T>>): void {
		this.resultStateSubscription?.unsubscribe();
		this.resultStateSubscription = source.subscribe(state => this.resultState.next(state));
	}

	disconnectResultState(): void {
		this.resultStateSubscription?.unsubscribe();
		this.resultStateSubscription = undefined;
		this.resultState.next(EMPTY_LIST_RESULT_STATE);
	}
}
